import { render } from "./IconCancel.vue?vue&type=template&id=6c25463a"
import script from "./IconCancel.vue?vue&type=script&lang=ts"
export * from "./IconCancel.vue?vue&type=script&lang=ts"
script.render = render

export default script